export default __webpack_public_path__ + "static/kortical-icon-f2f80e26f8652086b94e67130e324186.png";